__turbopack_context__.v({
  "container": "SelectionCard-module-scss-module__mFbhlq__container",
  "content": "SelectionCard-module-scss-module__mFbhlq__content",
  "disabled": "SelectionCard-module-scss-module__mFbhlq__disabled",
  "icon": "SelectionCard-module-scss-module__mFbhlq__icon",
  "input": "SelectionCard-module-scss-module__mFbhlq__input",
  "label": "SelectionCard-module-scss-module__mFbhlq__label",
});
